import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DbResponse} from "../../shared/interceptors/db-response";
import {UserService} from '../../user/user.service';
import {filter, first} from "rxjs/operators";

@Injectable()
export class EmailPreferencesResolver implements Resolve<any[]|null> {

  constructor(
    private _userService: UserService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      const userToken: string = route.params['userToken'];

      this._userService.getEmailPreferences(userToken)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          if (response.success && response.data) {
            resolve(response.data);
          }
          else {
            resolve(null);
          }
        });
    });
  }

}
